import React, { memo, useContext, useEffect, useRef, useState } from "react";
import { VIDEOS_DUMMY } from "./dummyData";
import { videoContext } from "../../contexts/VideoContext/VideoContextProvider";
import { MediaMetadataContext } from "../../contexts/MediaMetaDataContext/MediaMetadataContextProvider";
import styles from "./index.module.scss";
import dots from "../../assets/images/dots.png";
import playBtn from "../../assets/images/playBtnn.png";
import exclusiveIcon from "../../assets/images/exclusiveicon.png";
import premiumIcon from "../../assets/images/premiumicon.png";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import {
  scrollToTargetAdjusted,
  getURLParam,
  updateSearchParamsInURL,
  isNewTagShow,
} from "../../utils/common.utils";
import { Box, Shimmer } from "../ShimmerEffect";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import { VIDEO_CLICK } from "../../AppConstants/AnalyticsEventName";
import { ExclusiveType, VideoType } from "../../AppConstants/TypeConstants";
import { useLocation } from "react-router-dom";
import {
  algoliaCustomEvents,
  AlgoliaEventType,
  algoliaIndices,
} from "../../AppConstants/AlgoliaSearchConstants";
import { URL_PARAM_TAG } from "../../AppConstants/URLParam";
import {
  SPEAKER_INFO_ROUTE,
  VIDEO_PAGE_ROUTE,
  WEBINAR_PAGE_ROUTE,
} from "../../AppConstants/Routes";
import { ConstantDataContext } from "../../contexts/ConstantContext/ConstantDataContextProvider";
import { getStandaloneVideoData } from "../../Clevertap/EventHandler.ts";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/css/free-mode";
import "swiper/css/navigation";

const MINI_VIDEO_COUNT =
  window.innerWidth <= 1000 && window.innerWidth > 600
    ? 4
    : window.innerWidth <= 600 && window.innerWidth > 200
    ? 2.5
    : 5;

const searchRegExp = /[^A-Z0-9]/gi;
const replaceWith = "_";
function VideoCard({
  isModal = false,
  title,
  index,
  video,
  expandable,
  expanded,
  videosLength,
  toggleWrapper,
  pageToRedirect,
  fetchParameters,
  watchedPercentage,
  loading,
  pageEvent,
  sectionName,
}) {
  const history = useHistory();
  const { pathname, search = "", hash = "", state } = useLocation();
  const { globalDocflixConstant } = useContext(ConstantDataContext);
  const { addGAWithUserInfo, addCleverTapAnalytics, SearchEvent } =
    useContext(AnalyticsContext);

  const handleMouseHover = (e) => {
    if (video.playbackid && !e.target.src.includes(".gif")) {
      var rect = videoThumbnailRef.current.getBoundingClientRect();
      if (rect) {
        e.target.style.maxHeight = `${Math.round(rect.height)}px`;
        e.target.style.objectFit = `cover`;
        e.target.style.objectPosition = `top`;
      }
      e.target.src = `https://image.mux.com/${video.playbackid}/animated.gif${
        video.tokens && video.tokens.gifToken && video.tokens.gifToken !== ""
          ? `?token=${video.tokens.gifToken}`
          : ``
      }`;
    }
  };

  const videoThumbnailRef = useRef(null);

  const handleMouseLeave = (e) => {
    if (video.playbackid && !e.target.src.includes(".jpg")) {
      e.target.style.maxHeight = `unset`;
      e.target.style.objectFit = `initial`;
      e.target.style.objectPosition = `initial`;

      e.target.src = video.thumbnailUrl
        ? video.thumbnailUrl
        : `https://image.mux.com/${video.playbackid}/thumbnail.jpg${
            video.tokens &&
            video.tokens.thumbnailToken &&
            video.tokens.thumbnailToken !== ""
              ? `?token=${video.tokens.thumbnailToken}`
              : ``
          }`;
    }
  };

  const redirectToVideoDetailPage = (id) => {
    return history.push({ pathname: `/video/${id}`, search: search });
  };

  return (
    <Shimmer
      loading={loading}
      loadingComponent={
        <Box
          height={200}
          width={isMobileDevice ? "50%" : "24%"}
          marginRight={24}
        ></Box>
      }
      renderComponent={
        <div
          className={`${isModal?styles.card:styles.Videocard} ${
            !fetchParameters?.seasonRow ? "" : styles.seasonCard
          }`}
          key={index}
        >
          {/* {title === "Most Viewed" && (
            <div
              style={{
                color: "#fff",
                fontSize: "1.6rem",
                position: "absolute",
                top: "5%",
                zIndex: 5,
                left: "5%",
              }}
            >
              {String(index + 1).padStart(2, "0")}
            </div>
          )} */}

          <div
            onClick={() => {
              // if (
              //   videosLength > MINI_VIDEO_COUNT
              //     ? index !== MINI_VIDEO_COUNT
              //     : true
              // ) {
              addGAWithUserInfo(VIDEO_CLICK, { eventId: video.id });
              addCleverTapAnalytics(pageEvent, {
                ...getStandaloneVideoData(video),
                Section: sectionName ?? title,
              });

              redirectToVideoDetailPage(video.id);
              SearchEvent(
                AlgoliaEventType.Click,
                algoliaIndices.videos,
                algoliaCustomEvents.normalClick,
                [video.id]
              );

              // }
            }}
            className={`${styles.videoCard} ${
              isModal && !isMobileDevice ? styles.modalRow : ""
            }`}
            style={
              {
                // marginBottom: expandable && expanded ? "42px" : "0",
              }
            }
          >
            <div
              style={{
                position: "relative",
              }}
            >
              <img
                onMouseOver={handleMouseHover}
                onMouseLeave={handleMouseLeave}
                src={
                  video.thumbnailUrl
                    ? video.thumbnailUrl
                    : `https://image.mux.com/${video.playbackid}/thumbnail.jpg${
                        video.tokens &&
                        video.tokens.thumbnailToken &&
                        video.tokens.thumbnailToken !== ""
                          ? `?token=${video.tokens.thumbnailToken}`
                          : ``
                      }`
                }
                ref={videoThumbnailRef}
                alt={video.title}
                className={styles.videoThumb}
              />
              {/* <img src={playBtn} alt="playBtn" className={styles.playBtn} /> */}
              {video.type && video.type !== ExclusiveType.FREE && (
                <img
                  src={
                    video.type === ExclusiveType.PREMIUM
                      ? premiumIcon
                      : video.type === ExclusiveType.EXCLUSIVE
                      ? exclusiveIcon
                      : ""
                  }
                  alt={
                    video.type === ExclusiveType.PREMIUM
                      ? ExclusiveType.PREMIUM
                      : video.type === ExclusiveType.EXCLUSIVE
                      ? ExclusiveType.EXCLUSIVE
                      : ""
                  }
                  className={styles.videoType}
                />
              )}
              <div
                style={{
                  opacity: isNewTagShow(globalDocflixConstant, video),
                }}
                className={"videoTag"}
              >
                {video?.latestTag?.text ||
                  globalDocflixConstant?.videos?.latestTag?.text ||
                  "NEW"}
              </div>

              {index === MINI_VIDEO_COUNT && !expanded ? (
                expandable ? (
                  <>
                    {videosLength > MINI_VIDEO_COUNT && (
                      <div
                        onClick={() => toggleWrapper()}
                        className={`${styles.countCard} animate__animated animate__fadeIn`}
                      >
                        +{videosLength - MINI_VIDEO_COUNT} Videos
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {videosLength > MINI_VIDEO_COUNT && (
                      <Link
                        className={`${styles.countCard} animate__animated animate__fadeIn`}
                        to={{
                          pathname: pageToRedirect,
                          // search: getURLParam([
                          //   {
                          //     name: "tag",
                          //     value: fetchParameters.tags[0],
                          //   },
                          // ]),
                          search: updateSearchParamsInURL(
                            search,
                            URL_PARAM_TAG,
                            fetchParameters.tags &&
                              fetchParameters.tags.length > 0
                              ? fetchParameters.tags[0]
                              : fetchParameters.sectionId
                          ),
                          hash:
                            fetchParameters.tags &&
                            fetchParameters.tags.length > 0
                              ? fetchParameters.tags[0]
                              : fetchParameters.sectionId,
                          state: { preExpanded: true },
                        }}
                      >
                        +{videosLength - MINI_VIDEO_COUNT}
                      </Link>
                    )}
                  </>
                )
              ) : null}
            </div>
            {index !== MINI_VIDEO_COUNT ||
            expanded ||
            (index === MINI_VIDEO_COUNT && videosLength <= MINI_VIDEO_COUNT) ? (
              <>
                <div className={styles.durationBar}>
                  <div
                    style={{
                      width: `${watchedPercentage * 100}%`,
                      backgroundColor: "#EB4547",
                      position: "absolute",
                      height: "6px",
                      borderRadius: "4px",
                    }}
                  />
                </div>
                <div className={styles.rowData}>
                  <div className={styles.vtitle}>
                    {video.videoType === VideoType.VIDEO_SERIES
                      ? `E${video.videoData.episodeId} : ${video.title}`
                      : video.videoType === VideoType.TRAILER
                      ? `T : ${video.title}`
                      : video.title}
                  </div>
                  {/* <div>
                    <img src={dots} alt="menu" />
                  </div> */}
                </div>
              </>
            ) : null}
          </div>
        </div>
      }
    />
  );
}

const VideoSectionBreakpoint = {
  300: {
    slidesPerView: 1.7,
    spaceBetween: 15,
  },
  450: {
    slidesPerView: 3,
    spaceBetween: 15,
  },
  700: {
    slidesPerView: 3,
    spaceBetween: 15,
  },
  1024: {
    slidesPerView: 3.6,
    spaceBetween: 15,
  },
  1100: {
    slidesPerView: 4.5,
    spaceBetween: 15,
  },
  1350: {
    slidesPerView: 5.5,
    spaceBetween: 15,
  },
  1400: {
    slidesPerView: 5,
    spaceBetween: 15,
  },
  1500: {
    slidesPerView: 6,
    spaceBetween: 15,
  },
  1700: {
    slidesPerView: 6,
    spaceBetween: 15,
  },
  1920: {
    slidesPerView: 6,
    spaceBetween: 15,
  },
};

function VideosSection({
  isModal = false,
  title,
  fetchParameters,
  // videos = VIDEOS_DUMMY,
  pageToRedirect = VIDEO_PAGE_ROUTE,
  styledTitle = false,
  expandable = false, //expandable to next row
  hideViewAll,
  preExpanded = false,
  handleRowEnabled = false,
  pageEvent = "",
  sectionName = false,
}) {
  const { pathname, search = "", hash = "", state } = useLocation();

  const {
    rowVideos,
    getVideosByTag,
    getAllVideosByTag,
    getVideosBySpeakerId,
    getAllVideosBySpeakerId,
  } = useContext(videoContext);
  const { mediaMetadata } = useContext(MediaMetadataContext);

  const [expanded, setExpanded] = useState(preExpanded);
  const [videos, setVideos] = useState([]);
  const [sortBtnClicked, setSortBtnClicked] = useState(false);
  const [videosToMap, setVideosToMap] = useState(null);
  const calledForAllVideos = useRef(false);
  // const videosToMap = expanded ? videos : videos.slice(0, 4);

  useEffect(() => {
    // if (state && state.preExpanded) {
    //   setExpanded(state.preExpanded);
    // }
    if ("getSpeakerData" in fetchParameters) {
      getVideosBySpeakerId(fetchParameters);
    } else getVideosByTag(fetchParameters);
  }, []);

  useEffect(() => {
    if (rowVideos && rowVideos[fetchParameters.sectionId]) {
      let vid = rowVideos[fetchParameters.sectionId].videos || null;
      if (vid) {
        setVideosToMap(expanded ? vid : vid.slice(0, MINI_VIDEO_COUNT));
        setVideos(vid);
      }
      if (
        !calledForAllVideos.current &&
        expanded &&
        !fetchParameters.seasonRow
      ) {
        calledForAllVideos.current = true;
        "getSpeakerData" in fetchParameters
          ? getAllVideosBySpeakerId(fetchParameters)
          : getAllVideosByTag(fetchParameters);
      }
    } else {
      setVideosToMap([]);
    }

    let id = title.toLowerCase().trim().replace(searchRegExp, replaceWith);
    if (expanded && !fetchParameters.seasonRow) {
      setTimeout(() => {
        scrollToTargetAdjusted(id, 150);
      }, 500);
    }
  }, [rowVideos[fetchParameters.sectionId], expanded]);

  const toggleWrapper = () => {
    setExpanded(!expanded);
    // setTimeout(() => {
    //   document
    //     .getElementById(title)
    //     .scrollIntoView(
    //       expanded
    //         ? false
    //         : { behavior: "smooth", block: "end", inline: "nearest" }
    //     );
    // }, 100);
  };
  const sortAllEpisodes = () => {
    if (sortBtnClicked) {
      setSortBtnClicked(false);
      // console.log(videosToMap);
      setVideosToMap(videosToMap.reverse());
    } else {
      setSortBtnClicked(true);
      // console.log(videosToMap);
      setVideosToMap(videosToMap.reverse());
    }
  };

  return fetchParameters.sectionId === "recommended_for_you" ||
    fetchParameters.sectionId === "you_may_also_like" ||
    !videosToMap ||
    videosToMap.length <= 0 ? null : (
    <div
      className={`${styles.videosSection} ${
        fetchParameters.seasonRow ? styles.seasonSection : ""
      }`}
      id={title.toLowerCase().trim().replace(searchRegExp, replaceWith)}
    >
      <div
        className={styles.rowData}
        style={{
          marginRight: "24px",
        }}
      >
        {videosToMap?.length > 0 && (
          <>
            {(!pathname.includes(WEBINAR_PAGE_ROUTE) ||
              (videosToMap &&
                videosToMap.length > 0 &&
                pathname.includes(WEBINAR_PAGE_ROUTE))) &&
              !fetchParameters.seasonRow && (
                <div className={styles.title}>
                  {styledTitle ? (
                    <span>
                      <span
                        style={{
                          color: "#EB4547",
                        }}
                      >
                        {title.substring(0, 4)}
                      </span>
                      <span>{title.substring(4, title.length)}</span>
                    </span>
                  ) : (
                    title
                  )}
                </div>
              )}
            {videosToMap.length > 0 && title === "All Episodes" ? (
              <div onClick={sortAllEpisodes} className={styles.sortBtn}>
                {sortBtnClicked ? "Oldest First" : "Newest First"}
              </div>
            ) : null}
          </>
        )}
        {!hideViewAll && !("getSpeakerData" in fetchParameters) && (
          <>
            {expandable ? (
              <>
                {videos.length > MINI_VIDEO_COUNT && (
                  <div
                    onClick={() => toggleWrapper()}
                    className={styles.viewlink}
                  >
                    {expanded ? "View Less" : "View All"}
                  </div>
                )}
              </>
            ) : (
              videos.length > MINI_VIDEO_COUNT && (
                <Link
                  to={{
                    pathname: pageToRedirect,
                    // search: getURLParam([
                    //   {
                    //     name: "tag",
                    //     value: fetchParameters.tags[0],
                    //   },
                    // ]),
                    search: updateSearchParamsInURL(
                      search,
                      URL_PARAM_TAG,
                      fetchParameters.tags && fetchParameters.tags.length > 0
                        ? fetchParameters.tags[0]
                        : fetchParameters.sectionId
                    ),
                    hash:
                      fetchParameters.tags && fetchParameters.tags.length > 0
                        ? fetchParameters.tags[0]
                        : fetchParameters.sectionId,
                    state: { preExpanded: true },
                  }}
                  className={styles.viewlink}
                >
                  View {expanded ? "Less" : "More"}
                </Link>
              )
            )}
          </>
        )}
      </div>
      <div
        className={`${styles.videosWrapper} ${
          expandable && expanded ? styles.wrapped : null
        }`}
        id={title}
      >
        {isModal ? (
          <Swiper
            breakpoints={VideoSectionBreakpoint}
            navigation={!isMobileDevice && isModal}
            freeMode={true}
            modules={[FreeMode, Navigation]}
            speed={1000}
            className={styles.swiperContainer}
          >
            {videosToMap === null ? (
              React.Children.toArray(
                VIDEOS_DUMMY.map((video, index) => (
                  <SwiperSlide className={styles["swiper-slide"]} key={index}>
                    <VideoCard
                      isModal={isModal}
                      index={index}
                      video={video}
                      loading
                    />
                  </SwiperSlide>
                ))
              )
            ) : videosToMap.length === 0 ? (
              <>
                {pathname.includes(SPEAKER_INFO_ROUTE) && (
                  <div className={styles.comingSoon}>Coming soon</div>
                )}
              </>
            ) : (
              React.Children.toArray(
                videosToMap.map((video, index) => {
                  return (
                    <SwiperSlide className={styles["swiper-slide"]} key={index}>
                      <VideoCard
                        isModal={isModal}
                        title={title}
                        index={index}
                        video={video}
                        expandable={expandable}
                        expanded={expanded}
                        videosLength={videos.length}
                        toggleWrapper={toggleWrapper}
                        pageToRedirect={pageToRedirect}
                        fetchParameters={fetchParameters}
                        pageEvent={pageEvent}
                        sectionName={sectionName}
                        watchedPercentage={
                          mediaMetadata[video.id]
                            ? mediaMetadata[video.id].lastWatchTimestamp <=
                              mediaMetadata[video.id].totalDuration
                              ? mediaMetadata[video.id].lastWatchTimestamp /
                                mediaMetadata[video.id].totalDuration
                              : 1
                            : 0
                        }
                      />
                    </SwiperSlide>
                    // <div className={styles.card25} />
                  );
                })
              )
            )}
          </Swiper>
        ) : (
          <>
            {videosToMap === null ? (
              React.Children.toArray(
                VIDEOS_DUMMY.map((video, index) => (
                  <VideoCard
                    isModal={isModal}
                    index={index}
                    video={video}
                    loading
                  />
                ))
              )
            ) : videosToMap.length === 0 ? (
              <>
                {pathname.includes(SPEAKER_INFO_ROUTE) && (
                  <div className={styles.comingSoon}>Coming soon</div>
                )}
              </>
            ) : (
              React.Children.toArray(
                videosToMap.map((video, index) => {
                  return (
                    <VideoCard
                      isModal={isModal}
                      title={title}
                      index={index}
                      video={video}
                      expandable={expandable}
                      expanded={expanded}
                      videosLength={videos.length}
                      toggleWrapper={toggleWrapper}
                      pageToRedirect={pageToRedirect}
                      fetchParameters={fetchParameters}
                      pageEvent={pageEvent}
                      sectionName={sectionName}
                      watchedPercentage={
                        mediaMetadata[video.id]
                          ? mediaMetadata[video.id].lastWatchTimestamp <=
                            mediaMetadata[video.id].totalDuration
                            ? mediaMetadata[video.id].lastWatchTimestamp /
                              mediaMetadata[video.id].totalDuration
                            : 1
                          : 0
                      }
                    />
                    // <div className={styles.card25} />
                  );
                })
              )
            )}
          </>
        )}
      </div>
    </div>
  );
}

export { VideoCard };
export default memo(VideosSection);
